import parse from "url-parse";
import queryString from "query-string";

export default (link) => {
    const urlParsed = parse(link)
    const queryParsed = queryString.parse(urlParsed.query)
    return queryParsed.v
}